export const HardestQuiz = [
  {
    type: "singleInput",
    question: `Site 54 might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "16",
  },
  {
    type: "singleInput",
    question: `Site 4A might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "18",
  },
  {
    type: "input",
    question:
      "List 3 regular serviced sites that are usually ok with dining tents regardless of the trailer size, but that you shouldn't PROMISE them it will fit if they say it's important to them, because the dining tent might be half on a hill / in the woods a bit. (hint: two of the sites are side-by-side and usually booked together. The other one is in bay view.)",
    answers: ["6", "7", "A"],
  },
  {
    type: "singleInput",
    question: `Site M might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "16",
  },
  {
    type: "multiple",
    question: `If it's uncertain whether a dining tent will fit on a site, and that site is all that's left, you can say something like "we have a regular serviced site available that fits your trailer, but there is a chance your dining tent may not comfortably fit. You are welcome to bring it and try, and/or there is always the option of parking your car in the overflow parking lot to make more room on the campsite."`,
    correctAnswer: "This is a good thing to say",
    options: [
      "This is a good thing to say",
      "Tell them to find a different campground and never come back to Lands End",
    ],
  },
  {
    type: "singleInput",
    question: `Site H might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "14",
  },
  {
    type: "singleInput",
    question: `Site 76 might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "18",
  },
  {
    type: "singleInput",
    question: `Site 31 is hard to back in to, so it is best to avoid hard-sided trailers above __ feet`,
    answer: "19",
  },
  {
    type: "singleInput",
    question: `Site 50 might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "14",
  },
  {
    type: "input",
    question:
      "List the top 4 unserviced sites that are best for putting two tents on",
    answers: ["59", "61", "70", "T"],
  },
  {
    type: "singleInput",
    question: `Site 73 might not be able to fit a dining tent if the trailer on it is more than __ feet`,
    answer: "18",
  },
  {
    type: "multiple",
    question:
      "Which regular-serviced site in the back half of the park can not have trailers that have any slides, and no trailers that are more than 18' when closed? It has a hill to get on to it, and can fit up to a 22' truck camper or pop-up trailer, or a 20' motorhome.",
    correctAnswer: "H",
    options: ["H", "73", "Y", "70", "67"],
  },
  {
    type: "multiple",
    question: `This regular-serviced site has its hookups on "the wrong side" for trailers. We've never had a complaint about it (most people have longer cords than are needed to hook up on this site because at Provincial/National Parks the hookups are pretty far away), But still we prefer tents on it, barely, it's not a huge deal, just IF you are choosing between multiple sites I would pick the other for a trailer. No big deal at all, no warning needed.`,
    correctAnswer: "54",
    options: ["31", "50", "54", "H", "Q"],
  },
];
